const en = {
  welcome: {
    close: 'Close',
    tagline1: 'Make your picks.',
    tagline2: 'Climb the leaderboard.',
    tagline3: 'Win prizes.',
    howToPlay: 'How to Play',
    letsPlay: "Let's Play",
    altLogo: "Pick'em",
    altBrand: 'Circus Daily',
  },
  howToPlay: {
    back: 'Back',
    title: 'How To Play',
    demoQuestion: 'Who will win the match?',
    demoTeamUsa: 'USA',
    demoTeamBelgium: 'Belgium',
    step1Title: "Pick'Em",
    step1Description: 'Lock in your predictions before Kick-off',
    step2Title: 'Score Big',
    step2Description: 'Every correct pick earns you points',
    step3Title: 'Beat the Competition',
    step3Description: 'Outscore friends and fans on the leaderboard',
    step4Title: 'Take the Glory',
    step4Description: 'Win prizes and claim bragging rights',
    cta: "Got it, Let's Play",
  },
  game: {
    status: {
      loading: 'Loading...',
      locked: 'Locked',
      live: 'LIVE',
      complete: 'Complete',
      correct: 'correct',
    },
    actions: {
      edit: 'Edit',
      editPicks: 'Edit Picks',
      viewPicks: 'View Picks',
      playNow: 'Play Now',
      leaderboard: 'Leaderboard',
      viewLeaderboard: 'Leaderboard',
      viewResults: 'View Results',
    },
    results: {
      rank: 'Rank',
      totalPts: 'Total Pts',
    },
    labels: {
      start: 'Start:',
      picks: 'Picks:',
      firstPrize: '1st Prize:',
      vs: 'vs',
      yes: 'Yes',
      no: 'No',
      free: 'FREE',
      prizePool: 'Prize Pool:',
      prizePoolFallback: 'Prize Pool',
      numPicks: 'nº picks:',
      points: 'Points:',
      rank: 'Rank:',
      myPrize: 'My Prize:',
    },
    time: {
      day: 'Day',
      days: 'Days',
      hour: 'Hour',
      hours: 'Hours',
      soon: 'Soon',
      startingSoon: 'Starting soon...',
    },
    contestClosed: 'This game has started and this contest is closed.',
    fallbackTitle: 'Competition',
    fallbackTeam: 'Team {{n}}',
    fallbackPlayer: 'Player {{n}}',
    fallbackOption: 'Option {{n}}',
    unknownPlayer: 'Unknown Player',
    ordinals: {
      st: 'st',
      nd: 'nd',
      rd: 'rd',
      th: 'th',
    },
  },
  navigation: {
    filter: 'Filter',
    edit: 'Edit',
    chat: 'Chat',
    code: 'Code',
    mainNav: 'Main navigation',
    backToLobby: 'Back to Lobby',
    leaderboard: 'Leaderboard',
  },
  actions: {
    clear: 'Clear',
    quickPick: 'Quick Pick',
    favouritePick: 'Fav Picks',
    submitPicks: 'Continue to confirm',
    submitMyPicks: 'Submit my picks',
    editMyPicks: 'Edit my picks',
    submitting: 'Submitting...',
    confirmationTitle: 'Confirmation',
    termsAgreement: 'I have read and agreed to Circus Daily contest T&Cs',
    entryConfirmationMessage:
      'Please confirm your entry into this contest. You can edit your picks anytime up until start of the first game.',
    updateSelections: 'Update Selections',
    saveChanges: 'Save Changes',
    cancel: 'Cancel',
    retry: 'Retry',
    goBack: 'Go Back',
    tryAgain: 'Try again',
    reloadPage: 'Reload page',
    close: 'Close',
    back: 'Back',
  },
  tabs: {
    lobby: 'Lobby',
    myPicks: 'My Picks',
    play: 'Play',
    recent: 'Recent',
    leaderboard: 'Leaderboard',
  },
  filter: {
    all: 'All',
  },
  leaderboard: {
    today: 'Today',
    week: 'Week',
    season: 'Season',
    daily: 'Daily',
    monthly: 'Monthly',
    month: 'Month',
    rank: 'Rank',
    user: 'User',
    player: 'Player',
    points: 'Points',
    prize: 'Prize',
    pickem: 'Pickem',
    pickemLeaderboard: 'Pickem Leaderboard',
    close: 'Close',
    scrollForMore: 'Scroll for more',
    loadMore: 'Load more',
    scrollToTop: 'Scroll to top',
    failedToLoad: 'Failed to load leaderboard. Please try again.',
    noData: 'No leaderboard data available for this period.',
    absoluteWinner: 'Absolute winner - first correct entry submitted',
    loading: 'Loading leaderboard...',
    loadingShort: 'Loading...',
    weekLabel: 'Week {{n}}',
    globalTitle: 'Global Leaderboard',
    noActive: 'No active leaderboard',
    picksLoading: 'Loading picks...',
    noPicks: 'No picks available',
    prizeDetails: 'Prize Details',
    crowns: 'Crowns',
    noSelection: 'No selection',
    viewLeague: 'Leaderboard >',
    pickems: {
      loading: 'Loading pickems...',
      failed: 'Failed to load pickems.',
      empty: 'No pickems found.',
    },
    weekly: {
      loading: 'Loading weekly data...',
      failed: 'Failed to load weekly data.',
      empty: 'No weekly data available.',
    },
  },
  league: {
    settings: {
      title: 'SETTINGS',
      showLeaderboards: 'Show Leaderboards',
      users: 'Users',
      usersCount: '{{count}} Users',
      remove: 'Remove',
      deleteGroup: 'Delete Group',
      deleteConfirm: 'Delete this league?',
      deleteConfirmNamed: 'DELETE "{{name}}"?',
      deleteMessage: 'All friends will be removed from the leaderboard.',
      removePlayerConfirm: 'Remove this player?',
      removePlayerConfirmNamed: 'REMOVE "{{name}}"?',
      delete: 'Delete',
      cancel: 'Cancel',
      removePlayer: 'Remove Player',
    },
  },
  pages: {
    gamesCount: 'Select a contest',
    recentResults: 'Recent Results ({{count}})',
    noGamesAvailable: 'No Active Competitions',
    noGamesAvailableSubtitle:
      'There are no competitions running right now. Check back soon for new contests.',
    noCompletedGames: "There are no completed PICK'EM games yet.",
    noRecentResults: 'No Recent Results',
    noRecentResultsSubtitle:
      'Completed contests from the last 7 days will show up here. Check out the lobby to play.',
    noPicksSubmitted: 'No Picks Submitted',
    noPicksSubmittedSubtitle:
      'You currently have no picks to play. Check out the latest contests in the lobby to play.',
    viewAvailableContests: 'View available Contests',
  },
  common: {
    picks: 'pick{{plural}}',
    loading: 'Loading...',
    cancel: 'Cancel',
    retry: 'Retry',
    goBack: 'Go Back',
    back: 'Back',
    close: 'Close',
    error: 'Error',
  },
  a11y: {
    contestViews: 'Contest views',
    moreOptions: 'More options',
    contestDetails: 'Contest details',
    breadcrumb: 'Breadcrumb',
    scrollToTop: 'Scroll to top',
    contestLogo: 'Contest logo',
    goBack: 'Go back',
    leagueIcon: 'League icon',
    progress: 'Progress: {{completed}} of {{total}}',
  },
  footer: {
    termsAndConditions: 'Terms & Conditions',
  },
  tiebreaker: {
    title: 'Tiebreaker',
    defaultDescription: 'Predict the total score',
  },
  toast: {
    selectionsCleared: 'Your selections have been cleared!',
    quickPicks: {
      title: 'Quick picks selected!',
      description: 'Random selections have been made for all questions.',
    },
    popularPicks: {
      title: 'Popular picks selected!',
      description: 'Popular selections have been made for all questions.',
    },
    contestClosed: {
      title: 'Contest closed',
    },
    noSelections: {
      title: 'No selections',
      description: 'Please make at least one selection before saving.',
    },
    consentSaveFailed: {
      title: 'Unable to save consent',
      description: 'Please try again.',
    },
    submitSuccess: {
      title: 'Picks saved',
      description: 'Your selections have been submitted successfully.',
    },
    submitError: {
      title: 'Unable to save picks',
      description: 'Something went wrong. Please try again.',
    },
  },
  modal: {
    picksSubmitted: {
      title: 'Picks Submitted',
      message: 'Your picks are saved.',
      editMessage: 'Edit anytime before the contest starts.',
      returnToLobby: 'View My Picks',
      likeYourPicks: 'Like your picks?',
      buildBetSlip: 'Build a bet slip from your selections.',
      youCouldWin: 'YOU COULD WIN',
      fromBet: 'from a ${{amount}} bet',
      addToBetSlip: 'Add to Bet Slip',
    },
    quickPick: {
      title: 'Quick Pick Entry',
      description:
        "We'll fill your entry with random selections. Make changes anytime before locking in.",
      confirm: 'Randomise Picks',
    },
    favouritePick: {
      title: 'Favourite Picks',
      description: 'Quickly build your entry using the most selected picks from other players.',
      confirm: 'Select Favourites',
    },
    clearPicks: {
      title: 'Remove All Picks',
      description:
        'Remove your current selections and start fresh. You can choose new picks before submitting your entry.',
      confirm: 'Clear Picks',
    },
    clearSelections: {
      title: 'CLEAR SELECTIONS',
      confirm: 'Clear Pick',
      cancel: 'Cancel',
    },
    leagueCreated: {
      title: 'LEAGUE CREATED!',
      pinMessage: 'Share this PIN with friends to join your league.',
      copy: 'Copy',
      share: 'Share',
      viewLeague: 'View League',
      shareTitle: 'Join my league!',
      shareText: 'Use PIN {{pin}} to join my league.',
    },
    contestDetails: {
      title: 'Contest Details',
      rulesError: 'Unable to load rules. Please try again.',
      howToPlay: 'How to Play',
      dailyPrizes: 'Daily Prizes',
      monthlyPrizes: 'Monthly Prizes',
      payout: {
        title: 'Prize Payouts',
        rank: 'Rank',
        cash: 'Cash',
        crowns: 'Crowns',
      },
      fallback: {
        howToPlay1: 'Make your picks before the contest starts.',
        howToPlay2: 'Earn points for every correct selection.',
        howToPlay3: 'Climb the leaderboard and win prizes.',
        daily1: 'Daily prizes are awarded based on your rank.',
        monthly1: 'Monthly prizes are awarded at the end of the month.',
      },
    },
  },
  competition: {
    error: {
      notFound: 'Competition not found',
    },
    ipBlocked: {
      title: 'Access Restricted',
      message:
        'This contest is only available on Delta WiFi. Please connect to Delta WiFi to continue.',
    },
  },
  errors: {
    toastTitle: 'Error',
    network: 'Network error. Please check your connection.',
    loginRequired: 'Please log in to continue.',
    forbidden: 'You do not have permission to access this resource.',
    invalidRequest: 'Invalid request. Please check your input.',
    server: 'Server error. Please try again later.',
    unexpected: 'An unexpected error occurred.',
    occurred: 'An error occurred.',
    unableToConnect: 'Unable to connect. Please check your internet connection and try again.',
    sessionExpired: 'Your session has expired. Please log in again.',
    noPermission: 'You do not have permission to perform this action.',
    checkInput: 'Please check your input and try again.',
    serversIssues: 'Our servers are experiencing issues. Please try again in a few moments.',
    generic: 'Something went wrong. Please try again.',
  },
  errorBoundary: {
    title: 'Something went wrong',
    description: 'An unexpected error occurred. Please try again.',
    tryAgain: 'Try again',
    reloadPage: 'Reload page',
  },
  app: {
    configError: {
      title: 'Configuration Error',
      description: 'Failed to load application configuration. Please try again.',
    },
    authFailed: {
      title: 'Authentication Failed',
      clerkMissing: 'Authentication is not configured. Please contact support.',
    },
  },
  auth: {
    callback: {
      completing: 'Completing sign in…',
      pleaseWait: 'Please wait…',
      failed: 'Authentication Failed',
      missingToken: 'Missing authentication token.',
      returnHome: 'Return to Home',
    },
    clerk: {
      signIn: 'Sign in',
      createAccount: 'Create Account',
      alreadyHaveAccount: 'Already have an account?',
    },
  },
  marketingConsent: {
    headline: '$85,000 IN TOTAL PRIZES',
    subheadline: 'Brewed for Legendary Wins',
    checkboxPrompt:
      'Check the box below to receive exclusive offers, news, and updates from Modelo.',
    eligibilityText:
      "Participants must be 21+ to enter and a U.S. resident of the United States/DC. By clicking 'PLAY FREE' I affirm that I am 21 or older and a resident of the U.S. states/DC and have read and agree to the official rules.",
    footerText:
      "*For details about DraftKings' collection and use of your information, please see our Privacy Policy. You may opt out of having your information shared with Modelo by emailing privacy@cbrands.com.",
    buttonText: 'PLAY FREE',
    brandFallback: 'Draft Kings',
    consentBodyBeforeLinks:
      "I direct DraftKings to share my email address with Modelo and consent to use of my personal information for marketing, analytics, & targeted advertising, including conversion of my email address into identifiers, by Modelo & other CBI brands. Subject to Modelo's",
    consentBodyBetweenLinks: '&',
    consentBodyAfterLinks: '.',
    footerBeforePrivacy:
      "*For details about DraftKings' collection and use of your information, please see our",
    footerAfterPrivacy:
      '. You may opt out of having your information shared with Modelo by emailing',
    privacyPolicy: 'Privacy Policy',
    privacyNotice: 'privacy notice',
    userAgreement: 'Website User Agreement',
    a11y: {
      close: 'Close marketing consent',
      consentCheckbox: 'Consent to share information with Modelo',
    },
  },
  prize: {
    crownsSuffix: 'c',
  },
  date: {
    tbd: 'Date TBD',
    today: 'Today',
    tomorrow: 'Tomorrow',
    yesterday: 'Yesterday',
    days: '{{count}} Days',
    daysAgo: '{{count}} Days Ago',
    oneDayHyphen: '1-Day',
    daysHyphen: '{{count}}-Days',
  },
  friends: {
    challengeTitle: 'CHALLENGE YOUR FRIENDS',
    challengeSubtitle: 'Create a private leaderboard for you and your friends!',
    joinLeague: 'Join a League',
    createLeague: 'Create New League',
    inviteHint: 'Received an invite? Join using your PIN you received',
  },
  stats: {
    rushing_yards: 'Rushing Yards',
    passing_yards: 'Passing Yards',
    receptions: 'Receptions',
    receiving_yards: 'Receiving Yards',
    touchdowns: 'Touchdowns',
    passing_touchdowns: 'Passing TDs',
    rushing_touchdowns: 'Rushing TDs',
    interceptions: 'Interceptions',
    fumbles: 'Fumbles',
    sacks: 'Sacks',
    tackles: 'Tackles',
    points: 'Points',
    assists: 'Assists',
    rebounds: 'Rebounds',
    steals: 'Steals',
    blocks: 'Blocks',
    blocked_att: 'Blocked Attempts',
    blocked_shots: 'Blocked Shots',
    turnovers: 'Turnovers',
    three_points_made: '3-Pointers Made',
    three_points_att: '3-Point Attempts',
    three_points_pct: '3-Point %',
    two_points_made: '2-Pointers Made',
    two_points_att: '2-Point Attempts',
    two_points_pct: '2-Point %',
    free_throws_made: 'Free Throws Made',
    free_throws_att: 'Free Throw Attempts',
    free_throws_pct: 'Free Throw %',
    field_goals_made: 'Field Goals Made',
    field_goals_att: 'Field Goal Attempts',
    field_goals_pct: 'Field Goal %',
    minutes: 'Minutes',
    offensive_rebounds: 'Offensive Rebounds',
    defensive_rebounds: 'Defensive Rebounds',
    personal_fouls: 'Personal Fouls',
    plus_minus: 'Plus/Minus',
    double_doubles: 'Double Doubles',
    triple_doubles: 'Triple Doubles',
    goals: 'Goals',
    runs: 'Runs',
    hits: 'Hits',
    home_runs: 'Home Runs',
    rbi: 'RBIs',
    strikeouts: 'Strikeouts',
    soccer_goals: 'Goals',
    soccer_assists: 'Assists',
    soccer_shots: 'Shots',
    soccer_shots_on_target: 'Shots on Target',
    soccer_passes: 'Passes',
    soccer_pass_accuracy: 'Pass Accuracy',
    soccer_tackles: 'Tackles',
    soccer_clearances: 'Clearances',
    soccer_yellow_card: 'Yellow Cards',
    soccer_red_card: 'Red Cards',
    soccer_minutes_played: 'Minutes Played',
    soccer_saves: 'Saves',
    soccer_corners: 'Corners',
    soccer_fouls: 'Fouls',
    soccer_possession: 'Possession',
    soccer_team_goals: 'Team Goals',
    soccer_team_shots: 'Team Shots',
    soccer_team_shots_on_target: 'Team Shots on Target',
    soccer_team_yellow_cards: 'Team Yellow Cards',
    soccer_team_red_cards: 'Team Red Cards',
  },
  question: {
    over: 'Over',
    under: 'Under',
    selectPlayer: 'Select a player',
    selectTeam: 'Select a team',
    pick1Player: 'Pick 1 Player',
    pick1Team: 'Pick 1 Team',
    unknown: 'Unknown',
  },
} as const;

export default en;
